import { SunIcon, MoonIcon, ComputerDesktopIcon } from "@heroicons/react/24/outline";
import { useTheme } from "hocs/ThemeContext";

const OPTIONS = [
  { value: "light", icon: SunIcon, label: "Light" },
  { value: "system", icon: ComputerDesktopIcon, label: "System" },
  { value: "dark", icon: MoonIcon, label: "Dark" },
];

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();

  return (
    <div
      role="radiogroup"
      aria-label="Theme"
      className="inline-flex items-center rounded-md border border-border bg-card p-0.5"
    >
      {OPTIONS.map(({ value, icon: Icon, label }) => {
        const isActive = theme === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={isActive}
            aria-label={`${label} theme`}
            title={`${label} theme`}
            onClick={() => setTheme(value)}
            className={
              "flex h-5 w-5 items-center justify-center rounded-[3px] transition-colors " +
              (isActive
                ? "bg-accent text-foreground"
                : "text-muted-foreground/70 hover:text-foreground")
            }
          >
            <Icon className="h-3 w-3" />
          </button>
        );
      })}
    </div>
  );
};

export default ThemeToggle;
